import React from 'react';
import { t } from '../../utils/translations';

interface ResourcesWidgetProps {
  onOpenResources: () => void;
}

/** Sprout — heroicons has no plant glyph, so this matches their outline style. */
const SproutIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M12 21v-8.5" />
    <path d="M12 12.5c0-3.6 2.9-6.5 6.5-6.5 0 3.6-2.9 6.5-6.5 6.5Z" />
    <path d="M12 14.5c0-2.8-2.2-5-5-5 0 2.8 2.2 5 5 5Z" />
  </svg>
);

const ResourcesWidget: React.FC<ResourcesWidgetProps> = ({ onOpenResources }) => (
  <section className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm sm:p-6">
    <div className="flex items-start gap-3">
      <SproutIcon className="mt-0.5 h-6 w-6 shrink-0 text-brand-600" />
      <div className="min-w-0 flex-1">
        <h2 className="text-base font-semibold text-slate-900">
          {t.dashboard.resourcesWidget.title}
        </h2>
        <p className="mt-1 text-sm text-slate-600">{t.dashboard.resourcesWidget.body}</p>
        <button
          type="button"
          onClick={onOpenResources}
          className="mt-4 inline-flex items-center gap-1.5 rounded-lg border border-brand-200 bg-white px-3.5 py-2 text-sm font-medium text-brand-600 transition duration-200 ease-out hover:bg-brand-50 active:scale-[0.98]"
        >
          {t.dashboard.resourcesWidget.cta} →
        </button>
      </div>
    </div>
  </section>
);

export default ResourcesWidget;
